import { API } from '..';
import { ICategory, ICity, IUserProfile, UserProfileStats } from '../../models';

interface IDonateSettings {
  isSoundGoogle: boolean;
  colorText: string;
  animationText: string;
  animationIn: string;
  animationOut: string;
  sound: string;
  image: string;
  /** Streamer tự ẩn lịch sử donate công khai trên trang cá nhân. */
  hideDonationLog?: boolean;
}

export const fetchUserProfileByIdApi = (id: string) => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>(`/v1/user-service/users/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const fetchStatisticalByUserIdApi = (id: string) => {
  return new Promise<UserProfileStats>((resolve, reject) => {
    API.get<UserProfileStats>(`v1/post-service/users/statistical-user?userid=${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const fetchAllCategory = () => {
  return new Promise<[ICategory]>((resolve, reject) => {
    API.get<[ICategory]>(`/v1/user-service/users/get-categories`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const fetchAllCity = () => {
  return new Promise<[ICity]>((resolve, reject) => {
    API.get<[ICity]>(`/location/user-service/locations`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const updateUserDonateSettings = (settings: IDonateSettings) => {
  return new Promise<any>((resolve, reject) => {
    API.post<any>('/v1/user-service/usersettingsdonate', settings)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const getUserDonateSettings = () => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>(`/v1/user-service/usersettingsdonate/me`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const getUserDonateSettingsByUserID = (userId) => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>(`/v1/user-service/usersettingsdonate/${userId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
